import { Helmet } from "react-helmet";
import { Text, Heading } from "../../components";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import BlogsSection from "./BlogsSection";
import React from "react";

export default function BlogsPage() {
  return (
    <>
      <Helmet>
        <title>Industry Insights and Digital Twin Trends | Zwilling Labs Blogs</title>
        <meta
          name="description"
          content="Explore key trends, challenges, and success stories in Industry 4.0 and Digital Twin technology with Zwilling Labs' expert insights. Dive into our blogs for comprehensive solutions and industry advancements."
        />
      </Helmet>
      <div className="w-full bg-white">
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />
        <div className="mr-1.5 mt-[130px] flex flex-col items-center gap-[42px] md:mr-0">
          <div className="container-xs flex flex-col items-center px-14 md:px-5">
            <div className="mr-4 flex w-[84%] flex-col items-center gap-[18px] md:mr-0 md:w-full">
              <Heading
                size="heading7xl"
                as="h1"
                className="text-[24px] font-bold uppercase tracking-[2.40px] text-amber-800_01 md:text-[22px]"
              >
                blogs
              </Heading>
              <div className="flex flex-col items-center gap-2 self-stretch">
                <Heading
                  as="h2"
                  className="text-[46px] font-bold text-color_style-01_neutrals-grey800 md:text-[42px] sm:text-[36px]"
                >
                  Twin Perspectives
                </Heading>
                <Text
                  size="text11xl"
                  as="p"
                  className="self-stretch text-center text-[26px] font-normal leading-10 text-muted md:text-[24px] sm:text-[22px]"
                >
                  Join us on our blog as we highlight key trends, challenges, and success stories in Industry 4.0 and
                  the rapidly evolving Digital Twin landscape.
                </Text>
              </div>
            </div>
          </div>

          {/* blogs section */}
          <BlogsSection />
        </div>
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
      </div>
    </>
  );
}
